"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
function default_1({ isSticky, isPCView, isFixedPCView, children, }) {
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [isFixedPCView && (0, jsx_runtime_1.jsx)("div", { css: { height: '80px' } }), (0, jsx_runtime_1.jsx)("div", Object.assign({ css: {
                    position: isFixedPCView ? 'fixed' : isSticky ? 'sticky' : 'static',
                    left: 0,
                    bottom: 0,
                    display: 'flex',
                    justifyContent: 'center',
                    width: '100%',
                    height: isFixedPCView ? '80px' : 'unset',
                    borderTop: isFixedPCView ? '1px solid var(--gray-5)' : 0,
                    background: isFixedPCView
                        ? 'rgba(255, 255, 255, 0.80)'
                        : isPCView
                            ? 'var(--white)'
                            : 'linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.8) 26.97%, #FFFFFF 50.07%)',
                    backdropFilter: isFixedPCView ? 'blur(5px)' : 'unset',
                    zIndex: 10,
                } }, { children: (0, jsx_runtime_1.jsx)("div", Object.assign({ css: {
                        display: isPCView ? 'grid' : 'flex',
                        gridTemplateColumns: '100%',
                        '@media (max-width: 1440px)': { gridTemplateColumns: 'auto 180px' },
                        width: '100%',
                        maxWidth: '1024px',
                        padding: isFixedPCView ? '12px 0' : `${isPCView ? 20 : 60}px 16px 32px`,
                    } }, { children: (0, jsx_runtime_1.jsx)("div", Object.assign({ css: {
                            display: 'flex',
                            columnGap: isPCView ? '16px' : '10px',
                            justifyContent: isPCView ? 'flex-end' : 'space-between',
                            width: '100%',
                            button: {
                                width: isPCView ? 'unset' : '100%',
                                height: '56px',
                                minWidth: isPCView ? '183px' : 'unset',
                                borderRadius: '12px',
                                padding: '12px 36px',
                                fontSize: '18px',
                            },
                        } }, { children: children })) })) }))] }));
}
exports.default = default_1;
